import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import FileTree from "./components/FileTree.vue";

import fs, { configureSingle } from "@zenfs/core";
import { IndexedDB } from "@zenfs/dom";

import { inject, onMounted, ref } from "vue";

type FileNode = {
  name: string;
  path: string;
  type: "file" | "folder";
  children?: FileNode[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'DebugView',
  props: {
    nodes: {}
  },
  setup(__props: any) {



const tree = ref<FileNode[]>([]);
onMounted(async () => {
  await configureSingle({ backend: IndexedDB });

  const root = await buildFileTree("/");
  if (root.children) tree.value = root.children;
});

async function buildFileTree(path: string = "/"): Promise<FileNode> {
  const entries = await list(path);

  const node: FileNode = {
    name: path === "/" ? "/" : path.split("/").pop()!,
    path,
    type: "folder",
    children: [],
  };

  for (const entry of entries) {
    const fullPath = path === "/" ? `/${entry.name}` : `${path}/${entry.name}`;

    if (entry.type === "folder") {
      const child = await buildFileTree(fullPath);
      node.children!.push(child);
    } else {
      node.children!.push({
        name: entry.name,
        path: fullPath,
        type: "file",
      });
    }
  }

  return node;
}

async function list(path: string) {
  const entries = await fs.promises.readdir(path, { withFileTypes: true });

  return entries.map((e) => ({
    name: e.name,
    type: e.isDirectory() ? "folder" : "file",
  }));
}

async function clear() {
 await  fs.promises.rm("/", { recursive: true });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", { onClick: clear }, "删除数据"),
    _createVNode(FileTree, { nodes: tree.value }, null, 8, ["nodes"])
  ]))
}
}

})